<template lang="html">
    <div class="conText">
        <div class="backcolor">
            <div>
                <h2 class="h2css">联系我们 &nbsp;&nbsp;<span style="font-family:cursive;font-size:19px;">CONTACT US</span>
                </h2>
            </div>
            <div v-html="link.content.content" style="padding: 10px;"></div>
            <!--<div class="padding-10">
                <h3>【&nbsp;&nbsp;<span class="txt-color-red">四川吾言文化传播有限公司业务洽谈负责人名单</span>&nbsp;&nbsp;】</h3>
                <p>川北、川西负责人：徐秀文</p>
                <p>电话：18828073857 028－86893066 86893266</p>
                <p>川南、渝西负责人：付勇</p>
                <p>电话：18828073852 028－86893066 86893266</p>
                <p>川东、渝东负责人：聂海荣</p>
                <p>电话：18880468507 028－86893066 86893266</p>
                <h3>【&nbsp;&nbsp;<span class="txt-color-red">四川吾言文化传播有限公司业务洽谈负责人名单</span>&nbsp;&nbsp;】</h3>

                <p>广东、广西、湖北、湖南负责人：刘煜</p>
                <p>电话：18828073851 028－86893066 86893266</p>
                <p>云南、河南、陕西、甘肃、内蒙古负责人：曾强</p>
                <p>电话：15208301953 028－86893066 86893266</p>
                <p>福建、浙江、山东负责人：张伟峰</p>
                <p>电话：18828073850 028－86893066 86893266</p>
                <p>贵州负责人：漆晓林</p>
                <p>电话：18828073853 028－86893066 86893266</p>
            </div>

            <div class="padding-10">
                <h3>【&nbsp;&nbsp;<span class="txt-color-red">联系电话</span>&nbsp;&nbsp;】</h3>
                <p>建议·投诉：蒋经理</p>
                <p>电话:18880468509</p>
                <p>邮件:scwywh@126.com</p>
                <p>地址：四川省成都市金牛区沙湾东二路5号智业·世纪加州B座19层3/4号</p>
                <p>(已开通微信客服直接回复公众号24小时为您服务)</p>
            </div>-->
        </div>
    </div>
</template>
<script>
    import M from '../assets/common.js'
    import C from '../assets/config.js'

    export default {
        data: ()=>({
            host: C.host,
            link:{}
        }),
        created (){
            this.getInfo();
        },
        methods: {
            getInfo (){
                let url = this.host + 'wuyan/admin/notice/68';
                let self = this;
                M.load(url, '', function (data) {
                    if(!data.data) return;
                    data = data.data;
                    data.content = JSON.parse(data.content);
                    self.$set('link', data);
                }, 'get');
            }
        }
    }
</script>
<style scoped>
    .conText {
        padding: 10px 0px;
        width: 980px;
        margin: 20px auto;
        /*background: #e1ded7;*/
    }

    p {
        padding: 0;
        margin: 0;
    }

    .h2css {
        background: #dff0d8;
        padding: 10px;
        margin: 0;
        color: #3c763d;
        border-color: #d6e9c6;
    }

    .backcolor {
        background: url("../assets/lx.jpg") no-repeat bottom right #fff;
        border: 1px solid #e1ded7;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, .2);
        border-radius: 4px;
    }

    .padding-10 {
        padding: 10px;
    }
</style>


// WEBPACK FOOTER //
// tellOur.vue?3d78253f